import { HttpStatusCode } from 'axios';

import axios from 'src/utils/httpClients/axios';

import { HOST_API } from 'src/config';
import {
  WorkflowStateDto,
  WorkflowInstanceDto,
  WorkflowInstanceFilterDto,
  WorkflowMonitoringPageDto,
} from 'src/@types/workflow/types';

const baseUrl = `${HOST_API}workflow-instances`;

const documentWorkflowInstanceUrl = (documentId: number) =>
  `${HOST_API}documents/${documentId}/workflow-instance`;

export async function getWorkflowInstances(
  filter: WorkflowInstanceFilterDto,
  signal?: AbortSignal
): Promise<WorkflowMonitoringPageDto> {
  const response = await axios.get<WorkflowMonitoringPageDto>(baseUrl, { params: filter, signal });

  return response.data ?? { items: [], hasMore: false };
}

export async function getWorkflowInstance(
  instanceId: number,
  signal?: AbortSignal
): Promise<WorkflowInstanceDto> {
  const response = await axios.get<WorkflowInstanceDto>(`${baseUrl}/${instanceId}`, { signal });

  return response.data;
}

export async function cancelWorkflowInstance(
  instanceId: number,
  comment?: string
): Promise<WorkflowInstanceDto> {
  const response = await axios.post<WorkflowInstanceDto>(`${baseUrl}/${instanceId}/cancel`, {
    comment,
  });

  return response.data;
}

export async function startDocumentWorkflow(documentId: number): Promise<WorkflowStateDto> {
  const response = await axios.post<WorkflowStateDto>(documentWorkflowInstanceUrl(documentId), {});

  return response.data;
}

export async function getDocumentWorkflowInstance(
  documentId: number,
  signal?: AbortSignal
): Promise<WorkflowInstanceDto | null> {
  const response = await axios.get<WorkflowInstanceDto | null>(
    documentWorkflowInstanceUrl(documentId),
    { signal }
  );

  const hasNoRun = response.status === HttpStatusCode.NoContent;

  return hasNoRun ? null : response.data;
}
